import React from 'react'
export const CategoriesContext = React.createContext({})